<h2 mat-dialog-title>

  <span *ngIf="selectedRealEstateAgentItem.name">{{'COMMON.EDIT' | translate}} - {{selectedRealEstateAgentItem.name}}</span>
  <span *ngIf="!selectedRealEstateAgentItem.name">{{'COMMON.CREATE_NEW' | translate}}</span>

</h2>
<mat-dialog-content [formGroup]="form">


  <mat-tab-group (selectedTabChange)="onSelectedTabChanged($event)">
    <mat-tab class="modal-tab" label="{{'REAL_ESTATE_AGENT.ADMIN.TAB.0' | translate}}"></mat-tab>
    <mat-tab class="modal-tab" label="{{'REAL_ESTATE_AGENT.ADMIN.TAB.1' | translate}}"></mat-tab>
  </mat-tab-group>

  <form [formGroup]="form">
    <div class="tab-content-container">

      <div [hidden]="activeTabIndex !== 1" class="uploader-container">
        <img *ngIf="selectedRealEstateAgentItem && selectedRealEstateAgentItem.imageUrl"
             [src]="selectedRealEstateAgentItem.imageUrl">
        <mat-icon class="dark" *ngIf="selectedRealEstateAgentItem && selectedRealEstateAgentItem.imageUrl"
                  (click)="deleteCoverImage()">delete
        </mat-icon>
        <app-custom-drop-zone
          *ngIf="!selectedRealEstateAgentItem || !selectedRealEstateAgentItem.imageUrl"
          (uploadFinished)="onUploadFinished($event)"
          [uploadPath]="'realEstateAgent'"
          [height]="'250px'">
        </app-custom-drop-zone>
      </div>


      <div [hidden]="activeTabIndex !== 0">
        <div class="row">
          <div class="col-12">
            <mat-form-field>
              <input matInput
                     type="text"
                     placeholder="{{'REAL_ESTATE_AGENT.ADMIN.NAME' | translate}}"
                     formControlName="name">

            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field>
              <input matInput
                     type="text"
                     placeholder="{{'REAL_ESTATE_AGENT.ADMIN.TITLE' | translate}}"
                     formControlName="title">

            </mat-form-field>
          </div>

          <div class="col-12">
            <mat-form-field>
              <input matInput
                     type="text"
                     placeholder="{{'REAL_ESTATE_AGENT.ADMIN.PHONE' | translate}}"
                     formControlName="phone">

            </mat-form-field>
          </div>


          <div class="col-12">
            <mat-form-field>
              <input matInput
                     type="text"
                     placeholder="{{'REAL_ESTATE_AGENT.ADMIN.EMAIL' | translate}}"
                     formControlName="email">

            </mat-form-field>
          </div>

        </div>
      </div>

    </div>
  </form>

</mat-dialog-content>

<app-modal-footer [disabled]="!form.valid" (submit)="save()" (close)="close()"></app-modal-footer>
